import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { makeStyles } from '@material-ui/core/styles';
import HorizontalBarCard from './HorizontalBarCard';
import LineChartCard from './LineChartCard';
import PoweredByFN from './PoweredByFN';

const useStyles = makeStyles({
  root: {
    maxWidth: '100%',
    marginTop: 20,
    paddingBottom: 30,
    paddingLeft: 20,
    paddingRight: 20,
    border: '1px solid #C8CCD1',
  },
  cardTitleText: {
    marginTop: 30,
    marginBottom: 10,
    color: '#333333',
    fontSize: 24,
    fontWeight: 600,
    letterSpacing: 0,
  },
  cardSubtitleText: {
    marginBottom: 40,
    fontSize: 16,
    color: '#333333',
  },
  indicator: {
    backgroundColor: '#F9A51A',
    selected: 'none'
  },
  tabDefault: {
      outline: 'none',
      color: '#767676',
      fontFamily: 'Graphik',
      fontSize: 20,
      fontWeight: 600                                                                
  },
  tabSelected: {
      outline: 'none',
      color: '#333333',
      fontFamily: 'Graphik',
      fontSize: 20,
      fontWeight: 600                                                                
  },
  customButtonBaseRoot: {
    outline: 'none!important'
  }
});

const memberPresidentialSupportColor = '#005383';
const partyPresidentialSupportColor = '#6599CA';
const memberUnityColor = '#3F8776';
const partyUnityColor = '#86C7C0';
const memberVoteParticipationColor = '#A6396D';
const partyVoteParticipationColor = '#DE8AB2';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function getPresidentialSupportOptions(memberStats, partyStats) {
  partyStats = partyStats.slice(0, memberStats.length);

  return {
    title: "Presidental Support",
    xAxis: memberStats.map(stat => stat.voteyear),
    series: [{
      name: "member",
      color: memberPresidentialSupportColor,
      data: memberStats.map(stat => stat.memberPrezSupScore)
    },
    {
      name: "party",
      color: partyPresidentialSupportColor,
      data: partyStats.map(stat => stat.partyPrezSupScore)
    },
  ]
  }
}

function getPartyUnityOptions(memberStats, partyStats) {
  partyStats = partyStats.slice(0, memberStats.length);
  return {
    title: "Party Unity",
    xAxis: memberStats.map(stat => stat.voteyear),
    series: [{
      name: "member",
      color: memberUnityColor,
      data: memberStats.map(stat => stat.memberPartyUnityScore)
    },
    {
      name: "party",
      color: partyUnityColor,
      data: partyStats.map(stat => stat.partyPartyUnityScore)
    },
  ]
  }
}

function getVoteParticipationOptions(memberStats, partyStats) {
  partyStats = partyStats.slice(0, memberStats.length);
  return {
    title: "Vote Participation",
    xAxis: memberStats.map(stat => stat.voteyear),
    series: [{
      name: "member",
      color: memberVoteParticipationColor,
      data: memberStats.map(stat => stat.memberParticipationScore)
    },
    {
      name: "party",
      color: partyVoteParticipationColor,
      data: partyStats.map(stat => stat.partyParticipationScore)
    }
  ]
  }
}

function getPresidentialSupport(memberStats, partyStats) {
  const memberValue = memberStats[memberStats.length-1].memberPrezSupScore;
  const partyValue = partyStats[partyStats.length-1].partyPrezSupScore;

  return [
          {title:"Member Average", value: memberValue, color:memberPresidentialSupportColor},
          {title:"Party Average", value: partyValue, color:partyPresidentialSupportColor}
        ];
}

function getPartyUnity(memberStats, partyStats) {
  const memberValue = memberStats[memberStats.length-1].memberPartyUnityScore;
  const partyValue = partyStats[partyStats.length-1].partyPartyUnityScore;

  return [
          {title:"Member Average", value:memberValue, color:memberUnityColor},
          {title:"Party Average", value:partyValue, color:partyUnityColor}
        ];
}

function getVoteParticipation(memberStats, partyStats) {
  const memberValue = memberStats[memberStats.length-1].memberParticipationScore;
  const partyValue = partyStats[partyStats.length-1].partyParticipationScore;

  return [
          {title:"Member Average", value:memberValue, color:memberVoteParticipationColor},
          {title:"Party Average", value:partyValue, color:partyVoteParticipationColor}
        ];
}

function getMemberPartyStats(member, partyStats, years) {
  if (undefined === member || undefined === partyStats || undefined === member.memberStats
    || partyStats.length === 0 || member.memberStats.length === 0) {
      return null;
  } else {
    const chamber = member.memberCode.startsWith("H") ? "house":"senate";
    const party = member.party.label.toLowerCase();
    if (partyStats[chamber][party]) {
      const memberPartyStats = partyStats[chamber][party].sort((a, b) => {return a.voteyear - b.voteyear});
      return years.map(year => memberPartyStats.find(partyStat => partyStat.voteyear === year));
    } else {
      return null;
    }
  }
}

function getMemberStats(member) {
  if (undefined === member || undefined === member.memberStats || !Object.keys(member.memberStats).length) {
    return null;
  } else {
    return member.memberStats.sort((a, b) => {return a.voteyear - b.voteyear});
  }
}

const VotewatchCard = ({member = {}, partyStats = {}}) => { 
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes = useStyles();

  if (undefined === member || !Object.keys(member).length
    || undefined === partyStats || !Object.keys(partyStats).length) {
    return null;
  }

  const memberStats = getMemberStats(member);
  if (null === memberStats) {
    return null;
  }
  const memberPartyStats = getMemberPartyStats(member, partyStats, memberStats.map(stat => stat.voteyear));
  
  if (null === memberPartyStats) {
    return null;
  }

  return (
    <Card className={classes.root} variant='outlined'>
      <div className={classes.cardTitleText}>VoteWatch</div>
      <div className={classes.cardSubtitleText}>
        Voting trends for supporting the president, unity with their party and
        overall participation compared to the average member.
      </div>
      <Tabs
        value={value}
        onChange={handleChange}
        classes={{indicator: classes.indicator}}
        centered
      >
        <Tab classes={{root: classes.customButtonBaseRoot}} className={value===0 ?classes.tabSelected :classes.tabDefault}
          label="This Year" 
          />
        <Tab classes={{root: classes.customButtonBaseRoot}} className={value===1 ?classes.tabSelected :classes.tabDefault}
          label="Over Time"
          />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Grid container spacing={3}>
          <Grid key="PresidentialSupportBar" item xs={12} sm={6} md={4}>
            <HorizontalBarCard cardTitle="Presidential Support" bars={getPresidentialSupport(memberStats, memberPartyStats)} />
          </Grid>
          <Grid key="PartyUnityBar" item xs={12} sm={6} md={4}>
            <HorizontalBarCard cardTitle="Party Unity" bars={getPartyUnity(memberStats, memberPartyStats)} />
          </Grid>
          <Grid key="VoteParticipationBar" item xs={12} sm={6} md={4}>
            <HorizontalBarCard cardTitle="Vote Participation" bars={getVoteParticipation(memberStats, memberPartyStats)} />
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Grid container spacing={3}>
          <Grid key="PresidentialSupportChart" item xs={12} sm={6} md={4}>
            <LineChartCard cardTitle="Presidential Support" options={getPresidentialSupportOptions(memberStats, memberPartyStats)} />
          </Grid>
          <Grid key="PartyUnityChart" item xs={12} sm={6} md={4}>
            <LineChartCard cardTitle="Party Unity" options={getPartyUnityOptions(memberStats, memberPartyStats)} />
          </Grid>
          <Grid key="VoteParticipationChart" item xs={12} sm={6} md={4}>
            <LineChartCard cardTitle="Vote Participation" options={getVoteParticipationOptions(memberStats, memberPartyStats)} />
          </Grid>
        </Grid>
      </TabPanel>
      <PoweredByFN />
    </Card>
  );
};

export default VotewatchCard;
